<template lang="pug">
  v-container(fluid=true class="ma-0 pa-0")
    div(class="text-center")
      Heading(:title="$t('login.TITLE')")
      Description(:description="$t('login.DESCRIPTION')")
      v-flex(class="xs12 sm6 offset-sm3")

        ValidationObserver(ref="form" v-slot="{ validate, dirty }")
          form(@submit.prevent="onSubmit")
            v-layout(column)

              v-flex(class="ml-2 mr-2")
                ValidationProvider(name="email" rules="required|email")
                  div(slot-scope="{ errors }")
                    v-text-field(outlined background-color="white" id="email" name="email" type="email" :label="$t('login.EMAIL')" v-model="email" :data-vv-as="$t('login.EMAIL')" autocomplete="off" dense)
                    p(class="red--text caption") {{ errors[0] }}

              v-flex(class="ml-2 mr-2")
                ValidationProvider(name="password" rules="required")
                  div(slot-scope="{ errors }")
                    v-text-field(outlined id="password" name="password" type="password" :label="$t('login.PASSWORD')" v-model="password" :data-vv-as="$t('login.PASSWORD')" autocomplete="off")
                    p(class="red--text caption") {{ errors[0] }}

              v-flex(class="text-xs-center mt-5")
                SubmitButton(@click="validate().then(submit)" :text="$t('login.LOGIN')")

              v-flex(class="text-xs-center mt-4")
                v-btn(:to="{ name: 'forgotPassword' }" small=true text=true class="btnForgotPassword") {{ $t('login.FORGOT_PASSWORD') }}

        v-alert(v-show="!this.$browserDetect.isChrome" dense border="left" type="warning" color="blue-grey" class="body-2 ml-2 mr-2 mt-4") Nem todas as funcionalidades do sistema podem funcionar corretamente neste navegador, recomendamos o uso do &nbsp;
          a(href="https://www.google.com/chrome" class="white--text") Google Chrome.

      ErrorMessage
</template>

<script>
import router from '@/router'
import { mapActions } from 'vuex'
import { ValidationProvider, ValidationObserver, localize } from "vee-validate"

import pt_BR from "vee-validate/dist/locale/pt_BR.json";
import en from "vee-validate/dist/locale/en.json";
import es from "vee-validate/dist/locale/es.json";

export default {
  // metaInfo() {
  //   return {
  //     title: this.$store.getters.appTitle,
  //     titleTemplate: `${this.$t('login.TITLE')} - %s`
  //   }
  // },
  components: {
    ValidationProvider,
    ValidationObserver
  },
  data() {
    return {
      email: '',
      password: ''
    }
  },
  methods: {
    ...mapActions(['userLogin']),
    async onSubmit() {
      const valid = await this.$refs.form.validate();
      if (valid) {
        await this.userLogin({
          email: this.email,
          password: this.password
        })
      }
    }
  },
  computed: {
    lang(){
      return this.$store.getters.locale
    }
  },
  watch: {
    lang (newLang) { // se trocou a linguagem, revalida o form
      const lg = { en: en, pt: pt_BR, es: es };
      localize(`${newLang}`, lg[newLang]);
      this.$refs.form.validate();
    }
  },
  created() {
    if (this.$store.state.auth.isTokenSet) {
      router.push({ name: 'dashboard' })
    }
  }
}
</script>
